import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';
import { SwatchValidationError } from './SwatchValidationError';

export const { InvalidHexColorError } = errorFactory(
  'InvalidHexColorError',
  SwatchValidationError
);

/**
 * Error thrown when a swatch has an invalid hex color format.
 *
 * Valid formats are: #RGB, #RGBA, #RRGGBB, or #RRGGBBAA.
 * This error includes the invalid hex value(s) in the message.
 */
export type InvalidHexColorError = InstanceTypeOf<typeof InvalidHexColorError>;
